
<template>
  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Product & Technology</h1>
    </div>
    <div v-show="progress.stage_three === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">The Business (Onboarding)</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Kindly provide all the required information to proceed to the next stage.</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Click on the save draft button to save your progress</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">10mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="contain">
              <!-- <div v-show="windowWidth > 768" class="progress-bar relative">
                <div class="line w-[87%] bg-lineGray h-[2px] absolute mx-3 left-7 top-[7.5px]"></div>
                <div class="step flex flex-col items-center">
                  <div class="bullet active">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Product/Service</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Technology</p>
                </div>
                <div class="step flex flex-col items-center">
                  <div class="bullet">
                  </div>
                  <p class="title w-20 text-[12px] leading-[14.22px] mt-2 text-greyText font-Rubik">Schedule Meeting</p>
                </div>
              </div> -->
              <div class="progress relative bg-faintGrey rounded-[4px] py-3 px-4 mb-8">
                <div class="current-progress relative flex items-center justify-between active">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Product/Service
                  </div>
                  <div class="max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="text-black">1</span> of 3
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Technology
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">2</span> of 3
                  </div>
                </div>
                <div class="current-progress relative flex items-center justify-between">
                  <div class="min-w-[60%] font-Rubik text-black leading-[24px] font-medium">
                    Schedule Meeting
                  </div>
                  <div class="pages max-w-[40%] text-[#828282] font-Rubik leading-[24px] font-medium">
                    <span class="current-page text-black">3</span> of 3
                  </div>
                </div>
              </div>
              <div>
                <div class="form-outer">
                  <div class="forms">
                    <div class="page slide-page">
                      <div class="relative w-full mb-6">
                        <label
                          class="block font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal md:w-full w-[99%]"
                          for="product_milestones"
                        >
                          <span class="text-red-400">*</span>
                          What are the major product/service milestones over the next 12 months
                        </label>
                        <div v-for="(milestones, index) in data.product_milestones" :key="index" class="flex flex-col">
                          <div class="grid md:grid-cols-2 grid-cols-1 gap-2 mb-2">
                            <div class="milestone-wrap md:mr-2 mr-0 flex flex-col items-start justify-between">
                              <label
                                class="font-Rubik text-greyText text-[11px] leading-[13.04px] font-normal"
                                for="product_milestones_milestone"
                              >
                                MILESTONE Eg(launching new mobile app)
                              </label>
                              <input
                                v-model="v$.product_milestones.$model[index].milestone"
                                id="product_milestones_milestone"
                                name="product_milestones_milestone"
                                type="text"
                                :class="[
                                (v$.product_milestones.$each.$response.$data[index].milestone.$error && v$.product_milestones.$dirty) ? 'border-red-400' : 'border-grey-300'
                                ]"
                                class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                placeholder="E.g. launching new mobile app in January 2022"
                                style="transition: 'all .15s ease'"
                                @blur="v$.product_milestones.$touch()"
                              />
                              <div v-if="v$.product_milestones.$each.$response.$data[index].milestone.$error && v$.product_milestones.$dirty">
                                <p
                                  v-if="!v$.product_milestones.$each.$response.$data[index].milestone.required"
                                  class="text-red-400 text-[10px] font-light"
                                >Milestone is required</p>
                                <p
                                  v-if="!v$.product_milestones.$each.$response.$data[index].$invalid && !v$.product_milestones.$each.$response.$data[index].milestone.minLengthValue"
                                  class="text-red-400 text-[10px] font-light"
                                >Milestones should be at least 3 characters long</p>
                              </div>
                            </div>
                            <div class="date_time flex flex-col items-start justify-between">
                              <label
                                class="font-Rubik text-greyText text-[11px] leading-[13.04px] font-normal"
                                for="product_milestones_date"
                              >
                                <!-- <span class="text-red-400">*</span> -->
                                DATE
                              </label>

                              <div class="relative w-full">
                                <span v-if="index > 0" @click="removeField(data.product_milestones, index)" class="absolute inset-y-0 right-0 flex items-center pr-0 mt-[10px] h-[max-content] transform translate-y-[15px]">
                                  <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                  </svg>
                                </span>
                                <input
                                  v-model="v$.product_milestones.$model[index].date_time"
                                  id="product_milestones_date"
                                  name="product_milestones_date"
                                  type="date"
                                  :class="[
                                  (v$.product_milestones.$each.$response.$data[index].date_time.$error && v$.product_milestones.$dirty) ? 'border-red-400' : 'border-grey-300'
                                  ]"
                                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                                  style="transition: 'all .15s ease'"
                                  @blur="v$.product_milestones.$touch()"
                                />
                                <div v-if="v$.product_milestones.$each.$response.$data[index].date_time.$error && v$.product_milestones.$dirty">
                                  <p
                                    v-if="v$.product_milestones.$each.$response.$data[index].date_time.$invalid"
                                    class="text-red-400 text-[10px] font-light"
                                  >Date is required</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div @click="addNewField(data.product_milestones)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another milestone</p>
                        </div>
                      </div>
                      <!-- <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="milestones"
                        >
                          <span class="text-red-400">*</span>
                          What are the major product/service milestones over the next 12 months?
                        </label>
                        <div class="relative" v-for="(milestone, index) in data.product_milestones" :key="index">
                          <span v-if="index > 0" @click="removeField(data.product_milestones, index)" class="absolute inset-y-0 right-0 top-0 bottom-0 flex items-center pr-4 mt-2">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="milestones"
                            name="milestones"
                            type="text"
                            :class="[
                            (v$.product_milestones.$each.$response.$data[index].data.$error && v$.product_milestones.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="Company XYZ"
                            style="transition: 'all .15s ease'"
                            v-model="v$.product_milestones.$model[index].data"
                            @blur="v$.product_milestones.$touch()"
                          />
                          <div v-if="v$.product_milestones.$each.$response.$data[index].data.$error && v$.product_milestones.$dirty">
                            <p
                              v-if="v$.product_milestones.$each.$response.$data[index].data.$invalid"
                              class="text-red-400 text-[10px] font-light"
                            >Product milestones is required</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.product_milestones)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div> -->
                      <!-- <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="keyfeatures"
                        >
                          <span class="text-red-400">*</span>
                          What key features are on the product/service development road map? Please outline them by date if possible. Include information learnt from previous versions of the product/service.
                        </label>
                        <textarea
                          id="keyfeatures"
                          name="keyfeatures"
                          type="text"
                          rows="4"
                          :class="[
                          v$.key_features.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Lorem ipsum text"
                          style="transition: 'all .15s ease'"
                          v-model="v$.key_features.$model"
                          @blur="v$.key_features.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.key_features.length} of 400`}}</span>

                        <div v-if="v$.key_features.$error">
                          <p
                            v-if="v$.key_features.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Key features is required</p>
                        </div>
                      </div> -->
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="diffStrategy"
                        >
                          <span class="text-red-400">*</span>
                          What is the company's product/service differentiation strategy? In other words, how does the product/ service differ from that of others in the industry?
                        </label>
                        <textarea
                          id="diffStrategy"
                          name="diffStrategy"
                          type="text"
                          rows="4"
                          :class="[
                          v$.differentiation_strategy.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="400"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Superior quality of service, provision of embedded financial products, etc"
                          style="transition: 'all .15s ease'"
                          v-model="v$.differentiation_strategy.$model"
                          @blur="v$.differentiation_strategy.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.differentiation_strategy.length} of 400`}}</span>

                        <div v-if="v$.differentiation_strategy.$error">
                          <p
                            v-if="v$.differentiation_strategy.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Differentiation strategy is required</p>
                          <p
                            v-if="v$.differentiation_strategy.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Differentiation strategy should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="industrystandards"
                        >
                          <span class="text-red-400">*</span>
                          How does it compare to industry standards?
                        </label>
                        <textarea
                          id="industrystandards"
                          name="industrystandards"
                          type="text"
                          rows="4"
                          :class="[
                          v$.industry_standards.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Legacy industry players are largely analog, relying on pen and paper forms to complete transactions"
                          style="transition: 'all .15s ease'"
                          v-model="v$.industry_standards.$model"
                          @blur="v$.industry_standards.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.industry_standards.length} of 250`}}</span>

                        <div v-if="v$.industry_standards.$error">
                          <p
                            v-if="v$.industry_standards.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Industry standards is required</p>
                          <p
                            v-if="v$.industry_standards.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Industry standards should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="pricing"
                        >
                          <span class="text-red-400">*</span>
                          What is the pricing of the product or service?
                        </label>
                        <textarea
                          id="pricing"
                          name="pricing"
                          type="text"
                          rows="4"
                          :class="[
                          v$.pricing.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. $2+0.30% per transaction, $10 per user per month, etc"
                          style="transition: 'all .15s ease'"
                          v-model="v$.pricing.$model"
                          @blur="v$.pricing.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.pricing.length} of 250`}}</span>

                        <div v-if="v$.pricing.$error">
                          <p
                            v-if="v$.pricing.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Pricing is required</p>
                          <p
                            v-if="v$.pricing.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Pricing should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="pricingjustification"
                        >
                          <span class="text-red-400">*</span>
                          What is the justification for the price and How does the price of your firm's product or service compare relative to that of the competition?
                        </label>
                        <textarea
                          id="pricingjustification"
                          name="pricingjustification"
                          type="text"
                          rows="4"
                          :class="[
                          v$.pricing_justification.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Looking to grab market share with affordable price point, current price is 25% cheaper than competition but with higher quality of service"
                          style="transition: 'all .15s ease'"
                          v-model="v$.pricing_justification.$model"
                          @blur="v$.pricing_justification.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.pricing_justification.length} of 250`}}</span>
                        <div v-if="v$.pricing_justification.$error">
                          <p
                            v-if="v$.pricing_justification.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Price justification is required</p>
                          <p
                            v-if="v$.pricing_justification.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Pricing justification should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="unit-cost"
                        >
                          <span class="text-red-400">*</span>
                          What is the estimated unit cost of the product or service? Include a brief description of the breakdown of the unit cost of the product (Cost of Goods Sold) if available.
                        </label>
                        <textarea
                          id="unit-cost"
                          name="unit-cost"
                          type="text"
                          rows="4"
                          :class="[
                          v$.unit_cost.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. (delivery fee, 70%, insurance 5%, customer support and account management 5%, driver training 5%)"
                          style="transition: 'all .15s ease'"
                          v-model="v$.unit_cost.$model"
                          @blur="v$.unit_cost.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.unit_cost.length} of 250`}}</span>
                        <div v-if="v$.unit_cost.$error">
                          <p
                            v-if="v$.unit_cost.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Unit cost is required</p>
                          <p
                            v-if="v$.unit_cost.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Unit cost should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="liabilityrisks"
                        >
                          <span class="text-red-400">*</span>
                          Is the company aware of any product liability risks?
                        </label>
                        <textarea
                          id="liabilityrisks"
                          name="liabilityrisks"
                          type="text"
                          rows="4"
                          :class="[
                          v$.liability_risks.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. p2p money transmission features are subject to local know-your-customer and anti-money laundering provisions, the product’s collection of personal identifiable information (PII) can result in substantial harm to users if lost in a cyber breach."
                          style="transition: 'all .15s ease'"
                          v-model="v$.liability_risks.$model"
                          @blur="v$.liability_risks.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.liability_risks.length} of 250`}}</span>
                        <div v-if="v$.liability_risks.$error">
                          <p
                            v-if="v$.liability_risks.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Liability risk is required</p>
                          <p
                            v-if="v$.liability_risks.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Liability risk should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative flex md:justify-end justify-between w-full mb-6">
                        <button
                          class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
                          @click="onSaveDraft"
                        >
                          Save draft
                        </button>
                        <button :disabled="checkValidForm(v$, 'Product and service')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50" @click="goToStep2">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="metrics"
                        >
                          <span class="text-red-400">*</span>
                          List the programming languages, databases, app servers, open source components, and other tools and technologies that compose your product.
                        </label>
                        <div class="relative" v-for="(tech, index) in data.tech_stack" :key="index">
                          <span v-if="index > 0" @click="removeField(data.tech_stack, index)" class="absolute inset-y-0 right-0 top-0 bottom-0 flex items-center pr-4 mt-2">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="techs"
                            name="techs"
                            type="text"
                            :class="[
                            (v$.tech_stack.$each.$response.$data[index].data.$error && v$.tech_stack.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="E.g. microservices architecture, custom-built inventory management application, order management application, and integrations with external user management database and payment gateway"
                            style="transition: 'all .15s ease'"
                            v-model="v$.tech_stack.$model[index].data"
                            @blur="v$.tech_stack.$touch()"
                          />
                          <div v-if="v$.tech_stack.$each.$response.$data[index].data.$error && v$.tech_stack.$dirty">
                            <p
                              v-if="v$.tech_stack.$each.$response.$data[index].data.$invalid && v$.tech_stack.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Tech is required</p>
                            <p
                              v-if="v$.tech_stack.$each.$response.$data[index].data.$invalid && !v$.tech_stack.$each.$response.$data[index].data.minLengthValue"
                                class="text-red-400 text-[10px] font-light"
                              >Tech should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.tech_stack)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another field</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="devProcess"
                        >
                          <span class="text-red-400">*</span>
                          What is your software development process?
                        </label>
                        <textarea
                          id="devProcess"
                          name="devProcess"
                          type="text"
                          rows="4"
                          :class="[
                          v$.devops.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Agile software development framework with two-week sprint cycles"
                          style="transition: 'all .15s ease'"
                          v-model="v$.devops.$model"
                          @blur="v$.devops.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.devops.length} of 250`}}</span>
                        <div v-if="v$.devops.$error">
                          <p
                            v-if="v$.devops.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Development process is required</p>
                          <p
                            v-if="v$.devops.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Development process risk should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="roadmap"
                        >
                          <span class="text-red-400">*</span>
                          What key features are on the product/service development road map? Please outline them by date if possible. Include information learned from previous versions of the product/service.
                        </label>
                        <textarea
                          id="roadmap"
                          name="roadmap"
                          type="text"
                          rows="4"
                          :class="[
                          v$.development_roadmap.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. In-app chat and video for customer support by February 2022"
                          style="transition: 'all .15s ease'"
                          v-model="v$.development_roadmap.$model"
                          @blur="v$.development_roadmap.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.development_roadmap.length} of 250`}}</span>
                        <div v-if="v$.development_roadmap.$error">
                          <p
                            v-if="v$.development_roadmap.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Development Roadmap is required</p>
                          <p
                            v-if="v$.development_roadmap.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Development Roadmap should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="scalability"
                        >
                          <span class="text-red-400">*</span>
                          How scalable is the platform to allow for new features and/or for more users and transactions?
                        </label>
                        <textarea
                          id="scalability"
                          name="scalability"
                          type="text"
                          rows="4"
                          :class="[
                          v$.scalability.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. MVP product was built as a monolithic application, currently refactoring application into microservices to improve scalability"
                          style="transition: 'all .15s ease'"
                          v-model="v$.scalability.$model"
                          @blur="v$.scalability.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.scalability.length} of 250`}}</span>
                        <div v-if="v$.scalability.$error">
                          <p
                            v-if="v$.scalability.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Platform scalability is required</p>
                          <p
                            v-if="v$.scalability.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Platform scalability should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="metrics"
                        >
                          <span class="text-red-400">*</span>
                          Provide performance metrics and KPIs like time to version release, time to support request response, and time to fix critical bugs and security issues.
                        </label>
                        <div class="relative" v-for="(metric, index) in data.performance_metrics" :key="index">
                          <span v-if="index > 0" @click="removeField(data.performance_metrics, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2">
                            <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                          </span>
                          <input
                            id="metrics"
                            name="metrics"
                            type="text"
                            :class="[
                            (v$.performance_metrics.$each.$response.$data[index].data.$error && v$.performance_metrics.$dirty) ? 'border-red-400' : 'border-grey-300'
                            ]"
                            class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                            placeholder="E.g. time to version release, time to support request response, time to fix critical bugs and security issue, etc"
                            style="transition: 'all .15s ease'"
                            v-model="v$.performance_metrics.$model[index].data"
                            @blur="v$.performance_metrics.$touch()"
                          />
                          {{v$.performance_metrics.$each.$response.$data[index].$error}}
                          <div v-if="v$.performance_metrics.$each.$response.$data[index].data.$error && v$.performance_metrics.$dirty">
                            <p
                              v-if="v$.performance_metrics.$each.$response.$data[index].data.$invalid && v$.performance_metrics.$each.$response.$data[index].data.minLengthValue"
                              class="text-red-400 text-[10px] font-light"
                            >Performance metrics is required</p>
                            <p
                              v-if="v$.performance_metrics.$each.$response.$data[index].data.$invalid && !v$.performance_metrics.$each.$response.$data[index].data.minLengthValue"
                                class="text-red-400 text-[10px] font-light"
                              >Performance metrics should be at least 3 characters long</p>
                          </div>
                        </div>
                        <div @click="addDataField(data.performance_metrics)" class="flex items-center text-blueLink cursor-pointer">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                          </svg>
                          <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another metric</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="dataSecurity"
                        >
                          <span class="text-red-400">*</span>
                          How do you deal with data security and infrastructure security?
                        </label>
                        <textarea
                          id="dataSecurity"
                          name="dataSecurity"
                          type="text"
                          rows="4"
                          :class="[
                          v$.data_security.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Time to version release, time to support request response, time to fix critical bugs and security issue, etc"
                          style="transition: 'all .15s ease'"
                          v-model="v$.data_security.$model"
                          @blur="v$.data_security.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.data_security.length} of 250`}}</span>
                        <div v-if="v$.data_security.$error">
                          <p
                            v-if="v$.data_security.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Security and Infrastructure is required</p>
                          <p
                            v-if="v$.data_security  .minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Security and infrastructure should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="securityUpdates"
                        >
                          <span class="text-red-400">*</span>
                          How do you implement security updates?
                        </label>
                        <textarea
                          id="securityUpdates"
                          name="securityUpdates"
                          type="text"
                          rows="4"
                          :class="[
                          v$.security_update.$error ? 'border-red-400' : 'border-grey-300'
                          ]"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="E.g. Inventory all software and hardware systems quarterly, assign risk levels, sandbox and test patch releases, automate open source component patching"
                          style="transition: 'all .15s ease'"
                          v-model="v$.security_update.$model"
                          @blur="v$.security_update.$touch()"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.security_update.length} of 250`}}</span>
                        <div v-if="v$.security_update.$error">
                          <p
                            v-if="v$.security_update.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Security updates is required</p>
                          <p
                            v-if="v$.security_update.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Security updates should be at least 3 characters long</p>
                        </div>
                      </div>
                      <div class="relative w-full mb-6">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="businessContinuity"
                        >
                          What is your plan for business continuity in the face of attacks and malware, natural disasters, or political turmoil?
                        </label>
                        <textarea
                          id="businessContinuity"
                          name="businessContinuity"
                          type="text"
                          rows="4"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Describe the plan put in place for business continuity in the face of issues such as malware attacks, natural disasters or political turmoil"
                          style="transition: 'all .15s ease'"
                          v-model="v$.business_continuity.$model"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.business_continuity.length} of 250`}}</span>
                        <div v-if="v$.business_continuity.$error">
                          <p
                            v-if="v$.business_continuity.required.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Business continuity is required</p>
                          <p
                            v-if="v$.business_continuity.minLengthValue.$invalid"
                            class="text-red-400 text-[10px] font-light"
                          >Business continuity should be at least 3 characters long</p>
                        </div>
                      </div>
                      <!-- <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="dataRegulations"
                        >
                        How do you meet the data-related regulations required in each jurisdiction the company is active?
                        </label>
                        <textarea
                          id="dataRegulations"
                          name="dataRegulations"
                          type="text"
                          rows="4"
                          maxlength="250"
                          class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                          placeholder="Briefly describe how your product meets the data-regulating regulations in your jurisdictions"
                          style="transition: 'all .15s ease'"
                          v-model="data.data_regulations"
                        />
                        <span class="block w-max absolute right-0 font-Rubik font-light text-[12px] leading-[14.22px]">{{`${data.data_regulations.length} of 250`}}</span>
                      </div> -->
                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep1">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button :disabled="checkValidForm(v$, 'Technology')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                            Continue
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep1">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button :disabled="checkValidForm(v$, 'Technology')" class="bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50" @click="goToStep3">
                          Continue
                        </button>
                      </div>
                    </div>
                    <div class="page">
                      <div class="relative w-full mb-28">
                        <label
                          class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                          for="meetingTime"
                        >
                          <span class="text-red-400">*</span>
                          Schedule time to speak with the Kinfolk team
                        </label>
                        <div  class="mt-4 mb-2 flex items-center">
                          <Switch
                            v-model="enabled"
                            :disabled="calenderLoaded"
                            :class="enabled ? 'bg-black' : 'bg-lineGray'"
                            class="relative inline-flex flex-shrink-0 h-[31px] w-[51px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                          >
                            <span class="sr-only">Schedule meeting time</span>
                            <span
                              aria-hidden="true"
                              :class="enabled ? 'translate-x-5' : 'translate-x-0'"
                              class="pointer-events-none inline-block h-[27px] w-[27px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                            />
                          </Switch>
                          <p class="ml-4 text-black font-Rubik text-[15px] leading-[17.78px]">Schedule meeting time</p>
                        </div>
                        <svg v-if="enabled && !calenderLoaded" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="35px" height="35px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                          <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                          </circle>
                        </svg>
                        <div id="calender" class="h-[600px] mt-1">

                        </div>
                      </div>

                      <div v-if="windowWidth > 768" class="relative flex justify-between w-full mb-6">
                        <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none" @click="returnToStep2">
                          <span class="block mr-[8px] mb-[2px]">
                            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </span>
                          Back
                        </button>
                        <div class="flex items-center justify-end">
                          <button
                            class="flex bg-faintGrey text-[#666666] hover:text-black rounded-[6px] text-[16px] leading-[24px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50 mr-10"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                          <button
                            :disabled="!schedule_meeting"
                            @click="onSubmit"
                            class="flex bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50"
                          >
                            <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                            <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                              <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                              </circle>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div v-else class="relative flex flex-col justify-center w-full mb-6">
                        <div class="flex items-center justify-between w-full mb-8">
                          <button class="flex items-center justify-center border-[0.6px] border-[#D1D2D2] text-black rounded-[6px] text-[14px] font-Rubik leading-[20px] px-[28px] py-[14px] md:max-w-[157px] w-full mr-8 outline-none focus:outline-none" @click="returnToStep2">
                            <span class="block mr-[8px] mb-[2px]">
                              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16406 4.99935C1.16406 4.82254 1.2343 4.65297 1.35932 4.52794L5.35933 0.527944C5.61967 0.267594 6.04178 0.267594 6.30213 0.527944C6.56248 0.788293 6.56248 1.2104 6.30213 1.47075L3.4402 4.33268L11.1641 4.33268C11.5323 4.33268 11.8307 4.63116 11.8307 4.99935C11.8307 5.36754 11.5323 5.66602 11.1641 5.66602L3.4402 5.66601L6.30213 8.52794C6.56248 8.78829 6.56248 9.2104 6.30213 9.47075C6.04178 9.7311 5.61967 9.7311 5.35932 9.47075L1.35932 5.47075C1.2343 5.34573 1.16406 5.17616 1.16406 4.99935Z" fill="#0D0D0D" stroke="black" stroke-width="0.6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            Back
                          </button>
                          <button
                            class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50"
                            @click="onSaveDraft"
                          >
                            Save draft
                          </button>
                        </div>
                        <button
                          :disabled="!schedule_meeting"
                          @click="onSubmit"
                          class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] outline-none focus:outline-none disabled:opacity-50"
                        >
                          <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                          <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                            <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                              <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                            </circle>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_three === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_three ===  'Approved'" class="flex flex-col justify-between pt-4 pb-2 text-sm text-gray-500">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { Switch } from '@headlessui/vue'
import useVuelidate from '@vuelidate/core'
import { helpers, required, url, minLength } from '@vuelidate/validators'
import { useStore } from 'vuex'
import Helpers from '../../utils/helpers'
import StageThreeService from '@/services/stagethree.service'
import CompanyService from '@/services/company.service'
import store from '@/store'
import DraftService from '@/services/draft.service'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}
export default {
  components: {
    Switch
  },
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    // console.log(answer)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    let current = 2
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const typeRef = ref('')
    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })
    // const progress = reactive({
    //   stage1: true,
    //   stage2: false,
    //   stage3: true
    // })
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })

    const schedule_meeting = ref(false)
    const enabled = ref(false)
    const loading = ref(false)
    const calenderLoaded = ref(false)
    const windowWidth = ref(window.innerWidth)

    // const onWidthChange = () => {
    //   windowWidth.value = window.innerWidth
    // }
    // console.log(windowWidth.value)

    // onMounted(() => {
    //   window.addEventListener('resize', onWidthChange)
    // })
    // onUnmounted(() => {
    //   window.removeEventListener('resize', onWidthChange)
    // })

    const goToStep2 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.33%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep1 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '0%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    const goToStep3 = async () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-66.66%'
      // bullet[current - 1].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 1].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current += 1
    }

    const returnToStep2 = () => {
      const slidePage = document.querySelector('.slide-page')
      // const bullet = document.querySelectorAll('.step .bullet')
      const currentPage = document.querySelectorAll('.progress .current-progress')
      slidePage.style.marginLeft = '-33.33%'
      // bullet[current - 3].classList.add('active')
      // bullet[current - 2].classList.remove('active')
      currentPage[current - 3].classList.add('active')
      currentPage[current - 2].classList.remove('active')
      current -= 1
    }

    function isCalendlyEvent (e) {
      return e.data.event && e.data.event.indexOf('calendly') === 0
    }

    const getCalendar = () => {
      const name = store.state.app.company.company_name
      const email = store.state.auth.user.email
      // eslint-disable-next-line no-undef
      Calendly.initInlineWidget({
        url: process.env.VUE_APP_CALENDLY_URL,
        parentElement: document.getElementById('calender'),
        prefill: {
          name: name,
          email: email
        },
        utm: {}
      })
    }

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 3')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.product_milestones = draft.product_milestones
          data.key_features = draft.key_features
          data.differentiation_strategy = draft.differentiation_strategy
          data.industry_standards = draft.industry_standards
          data.pricing = draft.pricing
          data.pricing_justification = draft.pricing_justification
          data.unit_cost = draft.unit_cost
          data.liability_risks = draft.liability_risks
          data.tech_stack = draft.tech_stack
          data.devops = draft.devops
          data.development_roadmap = draft.development_roadmap
          data.scalability = draft.scalability
          data.performance_metrics = draft.performance_metrics
          data.data_security = draft.data_security
          data.security_update = draft.security_update
          data.business_continuity = draft.business_continuity
          data.data_regulations = draft.data_regulations
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        product_milestones: data.product_milestones,
        key_features: data.key_features,
        differentiation_strategy: data.differentiation_strategy,
        industry_standards: data.industry_standards,
        pricing: data.pricing,
        pricing_justification: data.pricing_justification,
        unit_cost: data.unit_cost,
        liability_risks: data.liability_risks,
        tech_stack: data.tech_stack,
        devops: data.devops,
        development_roadmap: data.development_roadmap,
        scalability: data.scalability,
        performance_metrics: data.performance_metrics,
        data_security: data.data_security,
        security_update: data.security_update,
        business_continuity: data.business_continuity,
        data_regulations: data.data_regulations
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 3',
        data: stagedata
      }
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const data = reactive({
      product_milestones: [
        {
          milestone: '',
          date_time: ''
        }
      ],
      key_features: '',
      differentiation_strategy: '',
      industry_standards: '',
      pricing: '',
      pricing_justification: '',
      unit_cost: '',
      liability_risks: '',
      tech_stack: [
        {
          data: ''
        }
      ],
      devops: '',
      development_roadmap: '',
      scalability: '',
      performance_metrics: [
        {
          data: ''
        }
      ],
      data_security: '',
      security_update: '',
      business_continuity: '',
      data_regulations: ''
    })

    const rules = computed(() => ({
      product_milestones: {
        $each: helpers.forEach({
          milestone: { required, minLengthValue: minLength(3) },
          date_time: { required }
        })
      },
      key_features: { required },
      differentiation_strategy: { required, minLengthValue: minLength(3) },
      industry_standards: { required, minLengthValue: minLength(3) },
      pricing: { required, minLengthValue: minLength(3) },
      pricing_justification: { required, minLengthValue: minLength(3) },
      unit_cost: { required, minLengthValue: minLength(3) },
      liability_risks: { required, minLengthValue: minLength(3) },

      tech_stack: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      devops: { required, minLengthValue: minLength(3) },
      development_roadmap: { required, minLengthValue: minLength(3) },
      scalability: { required, minLengthValue: minLength(3) },
      performance_metrics: {
        $each: helpers.forEach({
          data: { required, minLengthValue: minLength(3) }
        })
      },
      data_security: { required, minLengthValue: minLength(3) },
      security_update: { required, minLengthValue: minLength(3) },
      business_continuity: { required, minLengthValue: minLength(3) }
    }))

    const v$ = useVuelidate(rules, data)

    const addNewField = (arr) => {
      arr.push(
        {
          milestone: '',
          date_time: ''
        }
      )
    }
    const addNewString = (arr) => {
      arr.push(typeRef.value)
    }
    const addDataField = (arr) => {
      arr.push({
        data: ''
      })
    }
    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }

    const checkValidForm = (v$, screen) => {
      switch (screen) {
        case 'Product and service':
          if (v$.product_milestones.$invalid ||
          v$.differentiation_strategy.$invalid ||
          v$.industry_standards.$invalid ||
          v$.pricing.$invalid ||
          v$.pricing_justification.$invalid ||
          v$.unit_cost.$invalid ||
          v$.liability_risks.$invalid) {
            return true
          }
          break
        case 'Technology':
          if (v$.tech_stack.$invalid ||
          v$.devops.$invalid ||
          v$.development_roadmap.$invalid ||
          v$.scalability.$invalid ||
          v$.performance_metrics.$invalid ||
          v$.data_security.$invalid ||
          v$.security_update.$invalid) {
            return true
          }
          break
        default:
          return false
      }
    }

    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      const techStack = Helpers.changeToArray(data.tech_stack, 'data')
      const performanceMetrics = Helpers.changeToArray(data.performance_metrics, 'data')
      loading.value = true
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        product_milestones: data.product_milestones,
        differentiation_strategy: data.differentiation_strategy,
        industry_standards: data.industry_standards,
        pricing: data.pricing,
        pricing_justification: data.pricing_justification,
        unit_cost: data.unit_cost,
        liability_risk: data.liability_risks,
        tech_stack: techStack,
        devops: data.devops,
        development_roadmap: data.development_roadmap,
        scalability: data.scalability,
        performance_metrics: performanceMetrics,
        data_security: data.data_security,
        security_update: data.security_update,
        business_continuity: Helpers.changeEmptyStringtoNull(data.business_continuity),
        data_regulations: Helpers.changeEmptyStringtoNull(data.data_regulations)
      }
      try {
        const response = await StageThreeService.createStageThree(stagedata)
        if (response.status === 200 && response.data.status === 'success') {
          loading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)

          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        loading.value = false
        Helpers.processError(e, store, router)
      }
    }

    onMounted(() => {
      window.addEventListener(
        'message',
        function (e) {
          if (isCalendlyEvent(e)) {
            if (e.data.event === 'calendly.event_scheduled') {
              schedule_meeting.value = true
              const calendar = document.getElementById('calender')
              calendar.style.display = 'none'
            } else if (e.data.event === 'calendly.event_type_viewed') {
              calenderLoaded.value = true
            } else {
              calenderLoaded.value = false
              schedule_meeting.value = false
            }
          }
        }
      )
    })

    watch(
      () => enabled.value,
      (value) => {
        if (value === true) {
          getCalendar()
        }
      }

    )

    return {
      route,
      progress: computed(() => store.state.app.progress_status),
      disabled,
      goToStep2,
      returnToStep1,
      goToStep3,
      returnToStep2,
      enabled,
      v$,
      url,
      data,
      checkValidForm,
      addNewField,
      addNewString,
      addDataField,
      removeField,
      onSubmit,
      loading,
      getCalendar,
      schedule_meeting,
      calenderLoaded,
      windowWidth,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
.contain .form-outer{
  width: 100%;
  overflow: hidden;
}
.contain .form-outer .forms{
  display: flex;
  width: 300%;
}
.form-outer .forms .page{
  width: 33.33%;
  transition: margin-left 0.3s ease-in-out;
}
.contain .progress-bar{
  display: flex;
  justify-content: space-between;
  margin: 10px 5px 60px 5px;
  user-select: none;
}
.contain .progress-bar .step{
  text-align: center;
  position: relative;
}

.progress-bar .step .bullet{
  height: 16px;
  width: 16px;
  background-color: rgba(229, 230, 230, 1);
  display: flex;
  border-radius: 50%;
  position: relative;
  transition: 0.2s;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  z-index: 100;
  justify-content: center;
  align-items: center;
}

.progress-bar .step .bullet.active{
  background-color: #000000;
  height: 20px;
  width: 20px;
}
.progress-bar .step .bullet.active + p{
  color: #000000;
}
.progress-bar .step .bullet.active::after {
  content: "";
  height: 18px;
  width: 18px;
  background-color: transparent;
  border: solid 1px white;
  border-radius: 50%;
  position: absolute;
}
.progress .current-progress{
  display: none;
}
.progress .current-progress.active{
  display: flex;
}
</style>
